// import { BrowserTransferStateModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
// import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { RouterModule } from "@angular/router";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { CommonModule } from "@angular/common";
// import { TransferHttpCacheModule } from "@angular/ssr";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
// import { NgtUniversalModule } from "@ng-toolkit/universal";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppModule } from "./app.module";

@NgModule({ bootstrap: [AppComponent], imports: [
        // NgbModule,
        AppModule,
        FormsModule,
        RouterModule,
        CommonModule,
        AppRoutingModule,
        // NgtUniversalModule,
        // TransferHttpCacheModule,
        BrowserAnimationsModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class AppBrowserModule {}
